import { render, staticRenderFns } from "./CoursesCou.vue?vue&type=template&id=009ca5a6&scoped=true"
import script from "./CoursesCou.vue?vue&type=script&lang=js"
export * from "./CoursesCou.vue?vue&type=script&lang=js"
import style0 from "./CoursesCou.vue?vue&type=style&index=0&id=009ca5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ca5a6",
  null
  
)

export default component.exports